import { render } from "./AExpansionPanel.vue?vue&type=template&id=07843b0d"
import script from "./AExpansionPanel.vue?vue&type=script&lang=js"
export * from "./AExpansionPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__